<div class="popup-header">{{ categoryForm.get('name')?.value }}</div>
<form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <div class="container-fluid">
      <div class="row mt-3">
          <div class="form-group col-md-4">
          <label for="name">Name</label>
          <input type="text" id="name" class="form-control" formControlName="name">
        </div>
        <div class="form-group col-md-4">
          <label for="shelf">Shelf</label>
          <input type="number" id="shelf" class="form-control" formControlName="shelf">
        </div>
        <div class="form-group col-md-4">
          <label for="maxLife">Shelf life (days)</label>
          <input type="number" id="maxLife" class="form-control" formControlName="maxLife"
                 title="Used by the driver app to suggest svinn: products filled longer ago than this are presumed expired. A product's own shelf life overrides it.">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4 d-flex align-items-center">
          <input type="checkbox" id="activeCheck" formControlName="active" class="form-check-input align-checkbox ">
          <label for="activeCheck" class="mt-2">Active</label>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button type="button" mat-raised-button class="theme-button" (click)="onNoClick()">Close</button>
    <button type="submit" class="theme-button" mat-raised-button [disabled]="!categoryForm.valid">
      Save
    </button>
  </div>
</form>